module.exports = __webpack_public_path__ + "img/commentRate_4.9e42a92f.png";